import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicDecksPage } from '../../features/public-decks/public-decks-page';

const publicSearchSchema = z.object({
  q: z.string().optional(),
  tag: z.string().optional(),
  owner: z.string().optional(),
});

export const Route = createFileRoute('/_auth/public')({
  validateSearch: publicSearchSchema,
  component: PublicDecksPage,
});
